var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoorbell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 7H21V5C21 3.343 22.343 2 24 2C25.657 2 27 3.343 27 5V7Z",
    fill: "#8D6E63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 21C39 12.716 32.284 6 24 6C15.716 6 9 12.716 9 21C9 21.39 9 34 9 34H39C39 34 39 21.39 39 21Z",
    fill: "#EE8003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 34H9L5.125 35.55C4.445 35.822 4 36.48 4 37.211C4 38.199 4.801 39 5.789 39H42.211C43.199 39 44 38.199 44 37.211C44 36.48 43.555 35.822 42.875 35.55L39 34Z",
    fill: "#8D6E63"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28 39C28 41.209 26.209 43 24 43C21.791 43 20 41.209 20 39H28Z",
    fill: "#EE8003"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorbell);
export default __webpack_public_path__ + "static/media/doorbell.59b90fbf79b74b105b68f8624a4f179a.svg";
export { ForwardRef as ReactComponent };